const URL = '/transacciones';

const state = {
  all: [],
  selected: {
    id: null,
    transaccion_tipo: null,
    transaccion_detalle: null,
    glosas: [],
    fecha: null,
    cantidad: 0,
    coeficiente: 1,
    importe: 0,
    saldo: 0,
    detalle_saldos: {
      id: null,
      subsidio: null,
      usuario: null,
      pleno: null,
      demas: null
    },
    imputaciones: [],
    cuenta_id: null,
    precio_id: null,
    transferencia_origen: null,
    transferencias_destinos: [],
    diferencia_destino: null,
    diferencias_origenes: [],
    recibo_id: null,
    recibo_numero: null,
    cambio: null,
    desglose_pagos: [],
    created_at: null,
    updated_at: null,
    deleted_at: null,
    autor: null
  },
  edited: {
    id: null,
    transaccion_tipo: null,
    transaccion_detalle: null,
    glosas: [],
    fecha: null,
    cantidad: 0,
    coeficiente: 1,
    importe: 0,
    saldo: 0,
    detalle_saldos: {
      id: null,
      subsidio: null,
      usuario: null,
      pleno: null,
      demas: null
    },
    imputaciones: [],
    cuenta_id: null,
    precio_id: null,
    transferencia_origen: null,
    transferencias_destinos: [],
    diferencia_destino: null,
    diferencias_origenes: [],
    recibo_id: null,
    recibo_numero: null,
    cambio: null,
    desglose_pagos: [],
    created_at: null,
    updated_at: null,
    deleted_at: null,
    autor: null
  },
  filters: {
    fecha_from: null,
    fecha_to: null,
    borradas: 0,
    pendientes: 0,
    periodo: null,
    forma_pago_id: null,
    producto_id: null,
    cuenta_id: null,
    cuenta_saldo_id: null,
    export: 0,
  },
  loading: false,
  headers: [
    {
      text: '',
      value: 'id',
      align: 'center',
      width: '40px'
    },
    {
      text: 'Fecha',
      value: 'fecha',
      align: 'center'
    },
    {
      text: 'Detalle',
      value: 'transaccion_detalle',
      align: 'center'
    },
    {
      text: 'Cantidad',
      value: 'cantidad',
      align: 'center'
    },
    {
      text: 'Importe',
      value: 'importe',
      align: 'center'
    },
    {
      text: 'Deuda usuario',
      value: 'detalle_saldos.usuario',
      align: 'center'
    },
    {
      text: 'Subsidio a favor',
      value: 'detalle_saldos.subsidio',
      align: 'center'
    },
    {
      text: 'Deuda pleno',
      value: 'detalle_saldos.pleno',
      align: 'center'
    },
    {
      text: 'Dinero demás',
      value: 'detalle_saldos.demas',
      align: 'center'
    },
  ],
  options: {
    page: 1,
    itemsPerPage: 10,
    sortBy: [],
    sortDesc: []
  },
  itemsLength: null,
}

// GETTERS
const getters = {
  all(state) {
    return state.all
  },
  edited(state) {
    return state.edited
  },
  selected(state) {
    return state.selected
  },
  filters(state) {
    return state.filters
  },
  headers(state) {
    return state.headers
  },
  itemsLength(state) {
    return state.itemsLength
  },
  options(state) {
    return state.options
  },
  loading(state) {
    return state.loading
  },
}

// ACTIONS
const actions = {
  onClearAll({ commit }) {
    commit('setAll', [])
    commit('setOptions', {
      itemsPerPage: 10,
      page: 1,
      sortBy: [],
      sortDesc: []
    })
    commit('setItemsLength', null)
  },
  onClearFilters({ commit }) {
    commit('setFilters', {
      fecha_from: null,
      fecha_to: null,
      borradas: 0,
      pendientes: 0,
      periodo: null,
      forma_pago_id: null,
      producto_id: null,
      cuenta_id: null,
      cuenta_saldo_id: null,
      export: false,
    })
  },
  onClearEdited({ commit }) {
    commit('setEdited', {
      id: null,
      transaccion_tipo: null,
      transaccion_detalle: null,
      glosas: [],
      fecha: null,
      cantidad: 0,
      coeficiente: 1,
      importe: 0,
      saldo: 0,
      detalle_saldos: {
        id: null,
        subsidio: null,
        usuario: null,
        pleno: null,
        demas: null
      },
      imputaciones: [],
      transferencia_origen: null,
      transferencias_destinos: [],
      diferencia_destino: null,
      diferencias_origenes: [],
      recibo_id: null,
      recibo_numero: null,
      cambio: null,
      desglose_pagos: [],
      cuenta_id: null,
      created_at: null,
      updated_at: null,
      deleted_at: null,
      autor: null
    })
  },
  onClearSelected({ commit }) {
    commit('setSelected', {
      id: null,
      transaccion_tipo: null,
      transaccion_detalle: null,
      glosas: [],
      fecha: null,
      cantidad: 0,
      coeficiente: 1,
      importe: 0,
      saldo: 0,
      detalle_saldos: {
        id: null,
        subsidio: null,
        usuario: null,
        pleno: null,
        demas: null
      },
      imputaciones: [],
      transferencia_origen: null,
      transferencias_destinos: [],
      diferencia_destino: null,
      diferencias_origenes: [],
      recibo_id: null,
      recibo_numero: null,
      cambio: null,
      desglose_pagos: [],
      cuenta_id: null,
      created_at: null,
      updated_at: null,
      deleted_at: null,
      autor: null
    })
  },
  onFetch({ state, commit }) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true)
      axios.get(URL, {
        params: {
          itemsPerPage: state.options.itemsPerPage,
          page: state.options.page,
          sortBy: state.options.sortBy[0],
          sortDesc: state.options.sortDesc[0] ? 1 : 0,
          fecha_from: state.filters.fecha_from,
          fecha_to: state.filters.fecha_to,
          borradas: state.filters.borradas,
          pendientes: state.filters.pendientes,
          periodo: state.filters.periodo,
          cuenta_id: state.filters.cuenta_id,
          export: 0
        }
      })
        .then(response => {
          commit('setAll', response.data.data)
          commit('setItemsLength', response.data.meta.total)
          // Ajuste de paginación: si la página actual excede la última página disponible,
          // mover solo hasta la última página, no forzar siempre a 1
          {
            const total = Number(response.data.meta.total) || 0
            const per = Number(state.options.itemsPerPage) || 10
            const lastPage = Math.max(1, Math.ceil(total / per))
            if (state.options.page > lastPage) {
              commit('setPage', lastPage)
            }
          }
          resolve(response.data.data)
        })
        .catch(error => {
          reject(error)
        })
        .finally(() => {
          commit('setLoading', false)
        })
    })
  },
  onDelete({ state, commit, dispatch }, payload) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true)
      axios.delete(URL + '/' + state.edited.id, { data: { observaciones: payload } })
        .then(response => {
          commit('ResponseHTTP/addSuccess', 'Se ha borrado la transaccion', { root: true }) +
            dispatch('onClearEdited')
          dispatch('onClearSelected')
          resolve(response.data)
        })
        .catch(error => {
          commit('ResponseHTTP/addError', 'Error al borrar la transaccion', { root: true })
          reject(error)
        })
        .finally(() => {
          commit('setLoading', false)
        })
    })
  },
}

// MUTATIONS
const mutations = {
  setAll(state, payload) {
    state.all = payload.slice()
  },
  setEdited(state, payload) {
    state.edited = Object.assign({}, payload)
  },
  setSelected(state, payload) {
    state.selected = Object.assign({}, payload)
  },
  setFilters(state, payload) {
    state.filters = Object.assign({}, payload)
  },
  setLoading(state, payload) {
    state.loading = payload
  },
  setPage(state, payload) {
    state.options.page = payload
  },
  setItemsPerPage(state, payload) {
    state.options.itemsPerPage = payload
  },
  setItemsLength(state, payload) {
    state.itemsLength = payload
  },
  setOptions(state, payload) {
    state.options = payload
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
